import { COUNTRIES } from "./options";

export const findCountry = (shortcode: string) => {
  const country = COUNTRIES.find((country) => country.value === shortcode);

  return country ? country.label : "None";
};
